<template>
    <div>
        <v-row>
          <v-col class="pb-0" cols="12" sm="12" md="4" lg="3">
            <div :style="showLine">
                <LeftCertificacoes
                    ref="left"
                    @changeButton="changeIndex"
                    :index="index"
                />
              </div>
          </v-col>
          <v-col cols="12" sm="12" md="8" lg="9" :class="$vuetify.breakpoint.xs ? 'pt-0 pb-10': 'pb-10'">
              <RightCertificacoes
                style="height: 100%"
                ref="right"
                :index="index"
                @changeIndex="changeIndex"
                @complete="complete()"
              />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import LeftCertificacoes from './Shared/LeftCertificacoes'
import RightCertificacoes from './Shared/RightCertificacoes'
import jwtDecode from 'jwt-decode'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    LeftCertificacoes,
    RightCertificacoes
  },
  data () {
    return {
      index: 0,
      linhaVertical: {
        'border-right': '1px solid #DEE2E6',
        'height': '100%'
      },
      role: '',
      tokenBearer: localStorage.getItem('tokenBearer')
    }
  },
  beforeMount () {
    this.role = jwtDecode(this.tokenBearer).role
    EventBus.$emit('changeIndexCertificacoes', this.index)
  },
  methods: {
    closeError () {
      this.showError = false
      this.$router.push('/home')
    },
    async validarMudanca () {
      await this.$refs.right.validarMudanca()
    },
    complete () {
      this.$refs.left.changeDisabled()
    },
    saveVersao () {
      this.$refs.right.salvarVersao()
    },
    backStep () {
      if (this.index >= 0) {
        this.index--
      }
    },
    getResponseRight (boolean = false) {
      return this.$refs.right.salvaComponente(boolean)
    },
    async changeIndex (index) {
      let res = await this.getResponseRight()
      if (res) {
        this.index = index
        EventBus.$emit('changeIndexCertificacoes', index)
      }
    }
  },
  computed: {
    showLine () {
      return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? this.linhaVertical : ''
    }
  },
  watch: {
    index () {
      if (this.index === 1 && this.role !== 'admin' && this.role !== 'dirigente') {
        this.$emit('cancelar', true)
      } else {
        this.$emit('cancelar', false)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.linha
    border-top: 1px solid #DEE2E6
    width: 98%
    margin: 5px 0
</style>
